
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  *
  * The source file is located at:
  *   /codebuild/output/src2723206075/src/vl-app/pages/regulatory.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row, Tabs } from 'antd';
import { useRouter } from '@hooks/useRouter';
import { useArticleWrapped } from '@hooks/useArticleWrapped';
import styled from '@emotion/styled';
import AuthHeader from '@components/Layouts/Header/AuthHeader';
import useIsClinicianSubdomain from '@hooks/useIsClinicianSubdomain';

const StyledRegulatoryPage = styled.div`
  .accessibility-statement img {
    width: 80px !important;
  }

  .section-layout {
    max-width: 800px;
    margin: 0 auto;
  }

  .login-header {
    border-bottom: 1px solid #707070;

    .nav-panel {
      display: none !important;
    }
  }

  .title {
    font-weight: 600;
    font-size: 25px;
    margin-top: 25px;
    margin-bottom: 25px;
  }

  .login-bottom {
    position: relative;
    width: 100%;
    padding: 21px;
    background: #fff;
    align-items: center;
    display: flex;
    justify-content: center;
    font-weight: bold;
    border-top: 1px solid #707070;
  }

  .tabs-container {
    margin-top: 20px;
  }

  .tab-buttons {
    display: flex;
    gap: 12px;
    margin-bottom: 24px;
    flex-wrap: wrap;
  }
`;

function Regulatory() {
  const { t } = useTranslation('common');
  const router = useRouter();
  const [activeTab, setActiveTab] = useState('regulatory');
  const isClinicianSubdomain = useIsClinicianSubdomain();

  const regulatoryArticle = useArticleWrapped('regulatory', true);
  const instructionsArticle = useArticleWrapped('instructions_for_use', true);
  const clinicianInstructionArticle = useArticleWrapped('clinician_instructions', true);

  useEffect(() => {
    const { activeTab: queryActiveTab } = router.query;

    if (queryActiveTab && typeof queryActiveTab === 'string') {
      setActiveTab(queryActiveTab);
    }
  }, [router.query.activeTab]);

  const tabs = [
    {
      key: 'regulatory',
      label: t('Regulatory Statement'),
      article: regulatoryArticle
    },
    {
      key: 'instructions',
      label: t('Instructions for use'),
      article: instructionsArticle,
      hidden: isClinicianSubdomain
    },
    {
      key: 'clinician_instructions',
      label: t('Clinician Instructions for use'),
      article: clinicianInstructionArticle,
      hidden: !isClinicianSubdomain
    }
  ].filter((tab) => !tab.hidden);

  return (
    <StyledRegulatoryPage>
      <AuthHeader />
      <section className="section-layout">
        <h1 className="title">{t('Regulatory & Compliance')}</h1>

        <main className="container" id="page-content">
          <Row gutter={[0, 30]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <div className="tabs-container">
                <Tabs
                  activeKey={activeTab}
                  onChange={setActiveTab}
                  items={tabs.map((tab) => ({
                    key: tab.key,
                    label: tab.label,
                    children: (
                      <div className="app-table">
                        {tab.article && (
                          <div
                            className="accessibility-statement"
                            dangerouslySetInnerHTML={{ __html: tab.article.body }}
                          />
                        )}
                      </div>
                    )
                  }))}
                />
              </div>
            </Col>
          </Row>
        </main>
      </section>
    </StyledRegulatoryPage>
  );
}


export const Route = createFileRoute('/regulatory')({ component: Regulatory });
